import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import moment from 'moment';
import { isMatch } from 'react-day-picker';
import ProgressButton from '../../../../commons/ProgressButton';
import Service from '../services';
import Loader from '../../../../commons/loader';
import { PaginationTotal, DatePicker } from '../../../../commons/controls';
import NetworkEmptyState from '../../../../commons/networkemptystate';
import DataEmptyState from '../../../../commons/dataemptystate';
import Utility from '../Utility';
import NaptarModule from './NaptarModule';
import DayPickerHu from './DayPickerHu';
import {
  ModalNaptar,
  ModalNaptarChoice,
  ModalNaptarDelete,
  ModalNaptarView,
} from './Modals';
import CustomTooltip from '../../../../components/Tooltip/CustomTooltip';
import getTooltip from '../NaptarTooltips';
import RFForm from '../../../../components/Form/RFForm';
import RFField from '../../../../components/Form/RFField';

class NaptarNezetMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copySource: null,
      esemenytipusFilterSelected: null,
      esemenytipusOptions: [],
      email: false,
      insert: true,
      ismetlodesCheck: false,
      ismetlodesOptions: [],
      ismetlodesSelected: null,
      loading: false,
      modalMasolas: false,
      modalNaptar: false,
      modalNaptarChoice: false,
      modalNaptarTorles: false,
      modalNaptarView: false,
      naptarJSON: {},
      obj: {},
      orszagOptions: [],
      selectedDay: new Date(),
      selectedDays: [],
      naptartipusFilterSelected: null,
      naptartipusOptions: [],
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDD']
      tableStatus: 'HIDD',
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    if (this.hasRoleKarb()) {
      this.getIsmetlodesEnum();
    }
    this.updateFilters();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '1' && this.props.activeTab === '1') {
      this.updateFilters();
    }
  }

  hasRoleKarb = () => {
    return this.props.globals.hasRole(['NAPTAR_NAPTAR'], true);
  }

  getIsmetlodesEnum = () => {
    Service.listIsmetlodesEnum((err, res) => {
      if (!err) {
        let ismetlodesOptions = [];
        for (const obj of res[0]) {
          ismetlodesOptions.push(<option key={obj.name} value={obj.name}>{obj.nev}</option>);
        }
        this.setState({ ismetlodesOptions });
      }
    });
  }

  updateFilters = () => {
    this.updateNaptartipusFilter();
  }

  updateNaptartipusFilter = () => {
    Service.listNaptartipus(true, (err, res) => {
      if (!err) {
        let naptartipusOptions = [];
        for (let naptartipus of res[0]) {
          let option = <option value={naptartipus.id} key={naptartipus.id}>{naptartipus.nev + ' (' + naptartipus.azonosito + ')'}</option>;
          Utility.insertByOrder(naptartipusOptions, option);
        }
        this.setState({ naptartipusOptions });
      }
    });
  }

  updateIsmetlodesOption = (value) => {
    this.setState({ ismetlodesSelected: value });
  }

  updateTable = (buttonPress) => {
    const {
      naptartipusFilterSelected,
      selectedDay
    } = this.state;
    if (!naptartipusFilterSelected) {
      if (buttonPress != true) { this.updateNaptartipusFilter(); } else { this.props.globals.addError('Kereséshez naptártípus választása kötelező!'); }
    } else {
      let date = selectedDay;
      // Éjfélre ugrás
      date.setHours(0);
      this.setState({ tableStatus: 'LOAD' }, () => {
        Service.listNaptarNezet(date, naptartipusFilterSelected, (err, res) => {
          if (!err) {
            const status = !res[0].sorok || res[0].sorok.length == 0 ? 'DATA' : 'TABL';
            this.setState({ naptarJSON: res[0], tableStatus: status });
          } else {
            this.setState({ tableStatus: 'NETW' });
          }
        });
      });
    }
  }

  toggleIsmetlodesCheck = () => {
    this.setState((prevState) => { return ({ ismetlodesCheck: !prevState.ismetlodesCheck }); });
  }

  toggleNaptarView = () => {
    this.setState((prevState) => { return ({ modalNaptarView: !prevState.modalNaptarView }); });
  }

  toggleNaptar = (obj) => {
    this.setState((prevState) => {
      return ({
        modalNaptar: !prevState.modalNaptar, date: null, ...obj, ismetlodesCheck: false, ismetlodesSelected: null
      });
    });
  }

  toggleMasolas = () => {
    this.setState((prevState) => { return ({ modalMasolas: !prevState.modalMasolas, selectedDays: [], copySource: null }); });
  }

  toggleNaptarTorles = () => {
    this.setState((prevState) => { return ({ modalNaptarTorles: !prevState.modalNaptarTorles }); });
  }

  toggleNaptarChoice = () => {
    this.setState((prevState) => { return ({ modalNaptarChoice: !prevState.modalNaptarChoice }); });
  }

  handleEsemenytipusSelect = (esemenytipusid) => {
    this.setState((prevState) => {
      let esemenytipus = prevState.esemenytipusok.find(esemenytipusElement => esemenytipusElement.id == esemenytipusid);
      let timeObj = {};
      if (esemenytipus.kezdete) { timeObj.kezdet = new Date(esemenytipus.kezdete); }
      if (esemenytipus.vege) { timeObj.vege = new Date(esemenytipus.vege); } else if (esemenytipus.idotartam) { timeObj.vege = new Date(new Date(esemenytipus.kezdete).getTime() + esemenytipus.idotartam * 60000); }
      return { esemenytipusFilterSelected: esemenytipus.id, obj: { ...prevState.obj, ...timeObj } };
    });
  }

  handleNaptartipusSelect = (event, value) => {
    this.setState({ naptartipusFilterSelected: value });
    Service.listEsemenytipusByNaptartipus(value, (err, res) => {
      if (!err) {
        let esemenytipusOptions = [];
        for (const esemenytipus of res[0]) {
          if (esemenytipus.aktiv) {
            let option = <option value={esemenytipus.id} key={esemenytipus.id}>{esemenytipus.nev}</option>;
            Utility.insertByOrder(esemenytipusOptions, option);
          }
        }
        this.setState({ esemenytipusFilterSelected: null, esemenytipusOptions, esemenytipusok: res[0] });
      }
    });
  }

  handleDaySelect = (selectedDay) => {
    this.setState({ selectedDay });
  }

  handleMasolasDaySelect = (selectedDays) => {
    this.setState({ selectedDays });
  }

  handleNaptarViewClick = () => {
    this.toggleNaptarView();
  }

  handleNaptarAddClick = (obj) => {
    this.setState({ obj, insert: true, esemenytipusFilterSelected: null });
    this.toggleNaptar();
  }

  handleNapMasolasClick = () => {
    this.toggleMasolas();
  }

  handleNaptarChoiceClick = (naptarObj) => {
    this.setState({ loading: true });
    Service.getNaptar(naptarObj.id, (err, res) => {
      if (!err) {
        let obj = res[0];
        obj.date = new Date(obj.idokezdet);
        obj.kezdet = new Date(obj.idokezdet);
        obj.vege = new Date(obj.idovege);
        this.setState({ obj, loading: false, esemenytipusFilterSelected: res[0].esemenytipusid });
        this.toggleNaptarChoice();
      }
    });
  }

  handleNaptarEditClick = () => {
    this.toggleNaptar();
    this.setState({ insert: false });
  }

  handleNaptarDeleteClick = () => {
    this.toggleNaptarTorles();
  }

  dataOrEmptyString = (string) => {
    if (string) { return string; }
    return '';
  }

  insertStateFieldsIntoObject = (naptarObj) => {
    const {
      date,
      kezdet,
      vege
    } = this.state.obj;
    if (!date) {
      this.props.globals.addError('Dátum megadása kötelező!');
    } else if (!kezdet) {
      this.props.globals.addError('Az időtartam kezdetének megadása kötelező!');
    } else if (!vege) {
      this.props.globals.addError('Az időtartam végének megadása kötelező!');
    } else {
      let idokezdet = new Date(date);
      let idovege = new Date(date);
      idokezdet.setHours(kezdet.getHours());
      idokezdet.setMinutes(kezdet.getMinutes());
      idovege.setHours(vege.getHours());
      idovege.setMinutes(vege.getMinutes());
      // Ha a végénél éjfél van kiválasztva, akkor a következő napra át van léptetve a vége
      if (vege.getHours() == 0 && vege.getMinutes() == 0) {
        idovege.setDate(idovege.getDate() + 1);
      }
      naptarObj.idokezdet = idokezdet;
      naptarObj.idovege = idovege;
      return true;
    }
  }

  addNaptar = (event, naptarObj) => {
    let hiba = false;
    naptarObj.ismetlodesvege = this.state.obj.ismetlodesvege;
    if (this.state.ismetlodesCheck) {
      if (!naptarObj.ismetlodesvege) {
        this.props.globals.addError('Ismétlődés végének megadása kötelező!');
        hiba = true;
      } else {
        naptarObj.ismetlodesvege = new Date(naptarObj.ismetlodesvege);
      }
      naptarObj.szombat = naptarObj.szombat || false;
      naptarObj.vasarnap = naptarObj.vasarnap || false;
    }

    if(!naptarObj.ismetlodes) {
      naptarObj.naptarismetlodesenum = undefined;
      naptarObj.ismetlodesvege = undefined;
    }

    if (!hiba && this.insertStateFieldsIntoObject(naptarObj)) {
      Service.addNaptar(naptarObj, (err) => {
        if (!err) {
          this.toggleNaptar();
          this.updateTable();
          this.props.globals.addSuccess('Időtartam hozzáadva!');
        }
      });
    }
  }

  editNaptar = (event, naptarObj) => {
    naptarObj.id = this.state.obj.id;
    if (this.insertStateFieldsIntoObject(naptarObj)) {
      Service.editNaptar(naptarObj, (err) => {
        if (!err) {
          this.updateTable();
          this.toggleNaptar();
          this.props.globals.addSuccess('Időtartam módosítva!');
        }
      });
    }
  }

  deleteNaptar = () => {
    const {
      obj,
    } = this.state;
    this.toggleNaptarTorles();
    Service.deleteNaptar(obj && obj.id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Időtartam törölve!');
      }
    });
  }

  copyDay = () => {
    const {
      copySource,
      selectedDays,
      naptartipusFilterSelected,
    } = this.state;
    let obj = {
      cel: selectedDays,
      forras: copySource,
      naptartipusid: naptartipusFilterSelected,
    };
    if (!selectedDays.length) {
      this.props.globals.addError('Legalább egy cél nap kiválasztása kötelező!');
    } else {
      Service.copyDay(obj, (err, res) => {
        if (!err) {
          if (res[0] && res[0].length) {
            let uzenet;
            if (res[0].length > 1) {
              uzenet = 'A következő napok nem voltak szabadok a szükséges időkben: ';
              uzenet += res[0][0];
              for (let i = 1; i < res[0].length; i++) {
                const date = res[0][i];
                uzenet += ', ' + date;
              }
            } else {
              uzenet = 'A következő nap nem volt szabad a szükséges időkben: ' + res[0][0];
            }
            this.props.globals.addWarning(uzenet, 'tc', 0);
          } else {
            this.props.globals.addSuccess('Sikeres másolás!');
          }
          if (this.state.naptartipusFilterSelected) { this.updateTable(); }
          this.toggleMasolas();
        }
      });
    }
  }

  handleDateInputChange = (name, date) => {
    this.setState({ obj: { ...this.state.obj, [name]: new Date(date) } });
  }

  handleSelectInputChange = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({ [name]: value });
  }

  handleTimeChange = (name, date) => {
    if (date) {
      // let minutes = date.getMinutes();
      // let deviation = minutes % 5;
      // if (deviation) {
      //   this.props.globals.addWarning('Az időtartam perce csak öttel osztható szám lehet!');
      //   let correction = deviation <= 2 ? deviation : (deviation - 5);
      //   date.setMinutes(minutes - correction);
      // }
      // A kezdet és vege mező el van állítva, majd visszaírva, hogy React re-renderelje a mezőt akkor is, amikor a tárolt érték nem változott a korrigálás után
      // Például ha 13:35-ről 13:36-ra változtat a felhasználó, akkor alapba nem lenne re-render, mert a 13:35-re korrigált érték kerül beírásra,
      // és ez az érték van a változóban eredetileg is, de felületen 13:36 fog látni a felhasználó
      this.setState({ obj: { ...this.state.obj, [name]: new Date() } }, () => {
        this.setState({ obj: { ...this.state.obj, [name]: new Date(date) } });
      });
    }
  }

  setOrszaghivo = (value) => {
    this.state.orszagOptions.forEach((item) => {
      if (item.num === value) {
        this.setState({ orszaghivo: item.name.toUpperCase() });
      }
    });
  }

  renderState = () => {
    switch (this.state.tableStatus) {
      case 'NETW':
        return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
      case 'DATA':
        return <DataEmptyState hasImage subtitle="Rögzítsen új időtartamot" />;
      case 'TABL':
        return (
          <div style={{ marginTop: -30 }}>
            <NaptarModule
              JSON={this.state.naptarJSON}
              esemenytipusok={this.state.esemenytipusok}
              handleSzabadClick={this.handleNaptarChoiceClick}
              handleEmptyClick={this.handleNaptarAddClick}
            />
          </div>
        );
      case 'LOAD':
        return <Loader />;
      case 'HIDD':
        return <div />;
    }
  }
  
  checkDate = (name) => {
    let date = this.state.obj[name];
    if (date) {
      if (name) {
        if (name === 'kezdet') {
          date = new Date(this.state.obj.kezdet)
        }
        if (name === 'vege') {
          date = new Date(this.state.obj.vege)
        }
  
        let minutes = date.getMinutes();
        if (minutes.toString().length > 1) {
          let deviation = minutes % 5;
          if (deviation) {
            this.props.globals.addWarning("Az időpont perce csak öttel osztható szám lehet!");
            let correction = deviation <= 2 ? deviation : -(5 - deviation);
            date.setMinutes(minutes - correction);
          }
        } else {
          if (minutes < 3) {
            date.setMinutes(0);
          } else {
            date.setMinutes(5);
          }
        }
        
        if (date.getHours() * 60 + date.getMinutes() <= this.state.napkezdetora * 60 && !(date.getHours() == 0 && date.getMinutes() == 0)) {
          this.props.globals.addError("A naptár záró időpontja nem lehet korábbi, vagy ugyanaz, mint a naptár kezdő órája!");
          date = null;
        }
        this.setState({ obj: { ...this.state.obj, [name]: new Date(date) } });
    } else {
      this.setState({ obj: { ...this.state.obj, [name]: null } });
    }}
    
  }

  render() {
    const {
      naptartipusFilterSelected,
      naptartipusOptions,
    } = this.state;
    return (
      <div>
        <RFForm onSubmit={() => {}}>
          <div className="row">
            <div className="col-auto">
              <DayPickerHu
                mode="single"
                selected={this.state.selectedDay}
                onSelect={this.handleDaySelect}
                showOutsideDays
              />
            </div>
            <div className="col-md-3">
              <RFField
                type="select"
                label={'Naptártípus:'}
                defaultSelect={<option value="" disabled>Válassz naptártípust...</option>}
                selectOptions={naptartipusOptions}
                name="naptartipusselect"
                value={naptartipusFilterSelected}
                onChange={this.handleNaptartipusSelect}
              />
            </div>
            <div className="col">
              <div className="row">
                <div className="col-auto">
                  <Button className="pull-left table-new-button" color="primary" id="search" onClick={() => this.updateTable(true)}>Lekérdezés</Button>
                </div>
                {this.hasRoleKarb() && (
                <>
                  <div className="col-auto">
                    <Button className="pull-left table-new-button" color="primary" onClick={this.handleNaptarAddClick}>Új időtartam</Button>
                  </div>
                  {this.state.naptartipusFilterSelected && (
                  <div className="col-auto">
                    <Button className="pull-left table-new-button" color="primary" onClick={this.handleNapMasolasClick}>Nap másolása</Button>
                  </div>
                  )}
                </>
                )}
              </div>
            </div>
          </div>
        </RFForm>
        {this.renderState()}
        <Modal isOpen={this.state.modalMasolas} toggle={this.toggleMasolas} className={this.props.className} backdrop="static">
          <RFForm
            modal
            onSubmit={() => {}}
            title={
              <>
                Nap másolása
                <CustomTooltip text={getTooltip('masolas')} id="masolasTT" />
              </>
            }
            footer={
              <>
                <Button color="primary" onClick={this.copyDay}>Másolás</Button>
                <Button type="button" color="secondary" onClick={this.toggleMasolas}>Mégsem</Button>
              </>
            }
          >
            <ModalBody>
              <div>
                <Label for="copysource">Forrás nap: *</Label>
                <DatePicker
                  id="copysource"
                  name="copysource"
                  value={this.state.copySource && new Date(this.state.copySource)}
                  onChange={(e, date) => this.setState({ copySource: new Date(date) })}
                />
              </div>
              <Label>Cél nap(ok): *</Label>
              <DayPickerHu
                selected={this.state.selectedDays}
                onSelect={this.handleMasolasDaySelect}
                mode="multiple"
                showOutsideDays
              />
            </ModalBody>
          </RFForm>
        </Modal>
        <ModalNaptar
          addNaptar={this.addNaptar}
          className={this.props.className}
          editNaptar={this.editNaptar}
          handleDateInputChange={this.handleDateInputChange}
          handleNaptartipusSelect={this.handleNaptartipusSelect}
          handleTimeChange={this.handleTimeChange}
          handleEsemenytipusSelect={this.handleEsemenytipusSelect}
          isOpen={this.state.modalNaptar}
          state={this.state}
          toggle={this.toggleNaptar}
          toggleIsmetlodesCheck={this.toggleIsmetlodesCheck}
          updateIsmetlodesOption={this.updateIsmetlodesOption}
          checkDate={this.checkDate}
        />
        <ModalNaptarDelete
          className={this.props.className}
          isOpen={this.state.modalNaptarTorles}
          onOKClick={this.deleteNaptar}
          state={this.state}
          toggle={this.toggleNaptarTorles}
        />
        <ModalNaptarChoice
          className={this.props.className}
          deleteNaptar={this.handleNaptarDeleteClick}
          editNaptar={this.handleNaptarEditClick}
          isOpen={this.state.modalNaptarChoice}
          state={this.state}
          toggle={this.toggleNaptarChoice}
          viewNaptar={this.handleNaptarViewClick}
        />
        <ModalNaptarView
          className={this.props.className}
          isOpen={this.state.modalNaptarView}
          state={this.state}
          toggle={this.toggleNaptarView}
        />
      </div>
    );
  }
}

export default NaptarNezetMain;
